import styled from '@emotion/styled';
import color from 'src/theme/color';

export const UploadProgressContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 12px;
    margin-bottom: 16px;
`;

export const UploadProgressItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    padding: 8px;
    background-color: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
`;

export const UploadProgressFileInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 150px;
`;

export const UploadProgressFileName = styled.span`
    color: ${color.white};
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
`;

export const UploadProgressBarContainer = styled.div`
    flex: 1;
    min-width: 100px;
`;

export const UploadProgressBar = styled.div`
    width: 100%;
    height: 6px;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    overflow: hidden;
`;

export const UploadProgressFill = styled.div<{ progress: number }>`
    height: 100%;
    width: ${(props) => props.progress}%;
    background-color: ${color.lightningYellow};
    transition: width 0.3s ease;
`;

export const UploadProgressPercent = styled.span`
    color: ${color.white};
    font-size: 14px;
    min-width: 40px;
    text-align: right;
`;

export const UploadProgressCancelButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: rgba(255, 255, 255, 0.2);
    }

    svg {
        width: 12px;
        height: 12px;
        fill: ${color.white};
    }
`;
